export const SET_PROCESSING = 'PROCESSING/SET_PROCESSING';

export function setProcessing(processing) {
  return {
    type: SET_PROCESSING,
    processing: processing,
  };
}
